import { render, staticRenderFns } from "./StudentScholarshipApprovalPage.vue?vue&type=template&id=271d2068&scoped=true"
import script from "./StudentScholarshipApprovalPage.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipApprovalPage.vue?vue&type=style&index=0&id=271d2068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d2068",
  null
  
)

export default component.exports